/* ==========================================================================
   HAPŪ HELPERS — HEADER DROPDOWN: HOVER TO OPEN
   --------------------------------------------------------------------------
   Companion to assets/hapu-header-footer.css.

   Dawn's dropdown menus use <details>/<summary>, which by default open
   only on click. This script adds hover-to-open on the desktop nav while
   leaving click and keyboard behaviour intact.

   Behaviour:
     • Mouse enters a parent menu item → its dropdown opens
     • Mouse leaves with no return → dropdown closes after a short grace
       period (gives the user time to drift down into the panel)
     • Opening one dropdown closes any other open dropdown in the same nav
     • Touch / no-hover devices keep Dawn's native click behaviour
     • Below 990px (mobile), this script does nothing — Dawn's drawer
       takes over
   ========================================================================== */

(function () {
  'use strict';

  var HOVER_DELAY = 150; // ms — pause before closing on mouseleave

  function bindHover(details) {
    if (details._hhHoverBound) return;
    details._hhHoverBound = true;

    var closeTimer = null;

    details.addEventListener('mouseenter', function () {
      if (window.innerWidth < 990) return;

      clearTimeout(closeTimer);

      // Close siblings so we don't end up with multiple dropdowns open
      var siblings = document.querySelectorAll(
        '.header__inline-menu details[open], header-menu details[open]'
      );
      siblings.forEach(function (sibling) {
        if (sibling !== details) sibling.removeAttribute('open');
      });

      if (!details.hasAttribute('open')) {
        details.setAttribute('open', '');
      }
    });

    details.addEventListener('mouseleave', function () {
      if (window.innerWidth < 990) return;

      closeTimer = setTimeout(function () {
        if (details.hasAttribute('open')) {
          details.removeAttribute('open');
        }
      }, HOVER_DELAY);
    });
  }

  function init() {
    // Skip entirely on touch / no-hover devices to avoid phantom dropdowns
    if (!window.matchMedia('(hover: hover)').matches) return;

    var menuDetails = document.querySelectorAll(
      '.header__inline-menu details, header-menu > details'
    );
    menuDetails.forEach(bindHover);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
